import styled from '@emotion/styled';

export const DescriptionContainer = styled.div`
    padding: 0;
`;

export const CustomFieldTemplateContainer = styled.div`
    margin-top: 12px;
`;

export const FormPartDescription = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 2;
`;

export const DescriptionText = styled.p`
    font-size: 14px;
    line-height: 2;
    color: #0f172a;
    padding: 0;
    margin: 0;
`;

export const ErrorContainer = styled.div`
    color: #ef4444;
    background-color: #fff6f6;
    padding: 5px 15px;
    border-radius: 4px;
`;

type ButtonPropsType = {
    disabled?: boolean;
    variant?: 'primary' | 'secondary' | 'destructive' | 'outline' | 'ghost' | 'link' | 'loading';
};

export const ButtonForRJSF = styled.button`
    display: flex;
    height: 36px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    border: 1px solid #d4d4d8;
    cursor: ${(props: ButtonPropsType): string => (props.disabled === true ? 'not-allowed' : 'pointer')};
    opacity: ${(props: ButtonPropsType): number => (props.disabled === true ? 0.5 : 1)};
    
    ${(props: ButtonPropsType): string => {
        switch (props.variant) {
        case 'primary':
            return `
                background-color: #3B82F6;
                color: #fff;
                `;
        case 'secondary':
            return `
                background-color: #E4E4E7;
                color: #18181B;
                `;
        case 'destructive':
            return `
                background-color: #EF4444;
                color: #FAFAFA;
                `;
        default:
            return ``;
        }
    }}
    &:hover {
        opacity: ${(props: ButtonPropsType): number => (props.disabled === true ? 0.5 : 0.9)};
    }
    
    &:active {
        border: 1px solid #e4e4e7;
    }
`;

export const ObjectPropertyWrapper = styled.div`
    margin: 0 0 25px 0;
`;
